<template>
    <v-container fluid>   
      <LeftMenu/> 
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="personnels"
              :items-per-page="50"
              item-key="id"
              sort-by="currentSalary"
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"   
              @click:column="goToDetails"           
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Personnels</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2" v-on="on">New Personnel</v-btn>
                      
                      <v-flex xs12 sm6 md2>
                        <v-switch color="red" v-model="showPassive" class="mx-2" label="Show Passive"></v-switch>  
                      </v-flex>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                                                                                     
                            <v-flex xs12 sm6 md4>
                              <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-text-field v-model="editedItem.surname" label="Surname"></v-text-field>
                            </v-flex>  
                            <v-flex xs12 sm6 md4>  
                              <v-combobox
                                :items="userList"
                                label="Select Personnel User"
                                v-model="editedItem.user"
                                item-text="username"                              
                                single-line
                                return-object
                              ></v-combobox>                                                         
                            </v-flex>                           
                            <v-flex xs12 sm6 md3>
                              <v-text-field v-model="editedItem.title" label="Title"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-combobox
                                  :items="departmentList"
                                  label="Select Department"
                                  v-model="editedItem.department"
                                  item-text="name"
                                  single-line
                                  return-object
                              ></v-combobox> 
                            </v-flex>
                            <v-flex xs12 sm6 md3>                              
                              <DatePicker picker-label="Start Date" :date-value="editedItem.startDate" @dateSelected="editedItem.startDate=$event" /> 
                            </v-flex>             
                            <v-flex xs12 sm6 md3>                              
                              <DatePicker picker-label="Leave Date" :date-value="editedItem.leaveDate" @dateSelected="editedItem.leaveDate=$event" /> 
                            </v-flex>                                                                                                                                                                                                                                                                                                           
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>  
              <template v-slot:item.goToDetails="{ item }">              
                <v-icon                  
                  @click="goToDetails(item)">
                  mdi-send
                </v-icon>                
              </template>           
              <template v-slot:item.personnelsActions="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
const API_URL = 'definitions/personnel';
const REDUCED_PERSONNEL_URL = 'definitions/personnelReduced';
const USERS_API_URL = 'users';
const DEPARTMENTS_API_URL = 'definitions/departments';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    data () {
    return {
      dialog: false,
      showPassive : false,
      search: '',
      userList : [],
      departmentList: [],
      personnels: [
        {     
          name: ''         
        },               
      ],
      editedIndex: -1,
      editedItem: {
        model: '',
          name: ''
      },
      defaultItem: {
        model: '',
          Name: ''
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: '',align: 'left',sortable: false,value: 'goToDetails'},
        { text: 'Personnel Id',align: 'left',sortable: true,value: 'id'},
        { text: 'Name',  value: 'name'  },
        { text: 'Surname',  value: 'surname'  },
        { text: 'Start Date', value: 'startDate' },
        { text: 'Title',  value: 'title'  },        
        { text: 'Department', value: 'department.name' },
        { text: 'Summary TRY', value: 'summaryTRY',align: 'right' },
        { text: 'Summary USD', value: 'summaryUSD',align: 'right' },
        { text: 'Salary', value: 'currentSalary' },
        { text: 'Actions', value: 'personnelsActions', sortable: false },
      ]
    },   
    formTitle () {
      return this.editedIndex === -1 ? 'New Personnel' : 'Edit Personnel'
    },
  },
  created() {    
    this.getPersonnels(false);
    this.getDepartmentList();
    this.getUsers();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    showPassive(showPassive){     
      this.getPersonnels(showPassive);
    },
  },
  methods: {
    goToDetails(item){
      this.$router.push('/personnels/'+item.id);
    },
    editItem (item) {      
      console.log(item)   ;
      this.editedIndex = this.personnels.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.personnels.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.personnels.splice(index, 1);
        this.deletePersonnel(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updatePersonnel(this.editedItem);
      } else {
        this.addPersonnel(this.editedItem);         
      }      
    },
    addPersonnel(item){
      console.log(item);   
      var username =  "";
      if(item.user && item.user.username) {
        username = item.user.username ;
      } 

      this.$axios.post(this.$apiurl + API_URL, {
        name: item.name,
        surname:item.surname,
        startDate: item.startDate,
        leaveDate: item.leaveDate,
        title: item.title,
        departmentId: item.department ? item.department.id : 1,
        username: username
      })
      .then(response => {        
        if (response.status === 201) {
          this.personnels.push(this.editedItem);
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updatePersonnel(item){
      console.log(item);
      var username =  "";
      if(item.user && item.user.username) {
        username = item.user.username ;
      }

      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        name: item.name,
        surname:item.surname,
        startDate: item.startDate,
        leaveDate: item.leaveDate,
        title: item.title,
        departmentId: item.department ? item.department.id : 1,
        username: username
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.personnels[this.editedIndex], this.editedItem);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deletePersonnel(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getPersonnels(showPassive){ 
      
      var url = this.$apiurl + REDUCED_PERSONNEL_URL;
      if(showPassive){
        url += '/status/'+false;
      }else{
         url += '/status/'+true;
      }
        this.$axios.get(url)
            .then(response => {
                this.personnels = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },          
    getUsers(){     
        this.$axios.get(this.$apiurl + USERS_API_URL)
            .then(response => {
                this.userList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getDepartmentList(){     
        this.$axios.get(this.$apiurl+DEPARTMENTS_API_URL)
            .then(response => {
                this.departmentList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
<style scoped>
.passivePersonnel {
    color: red;
}
</style>
